var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1556_7581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 0C17.735 0 14.2656 3.55532 14.2656 7.82031C14.2656 12.0853 17.735 15.5547 22 15.5547C26.265 15.5547 29.7344 12.0853 29.7344 7.82031C29.7344 3.55532 26.265 0 22 0Z",
    fill: "#EB2019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5788 15.5547H22.0007H19.4226C17.6043 15.5547 15.8473 16.0247 14.25 16.8242C16.963 17.5563 19.5174 18.6105 22.0007 20.0359C24.4841 18.6105 27.0384 17.5563 29.7514 16.8242C28.1541 16.0247 26.3971 15.5547 24.5788 15.5547Z",
    fill: "#EB2019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4219 23.2891C39.998 23.2891 38.8438 24.4433 38.8438 25.8672V31.0234C38.8438 32.4472 39.998 33.6016 41.4219 33.6016C42.8458 33.6016 44 32.4472 44 31.0234V25.8672C44 24.4433 42.8458 23.2891 41.4219 23.2891Z",
    fill: "#EB2019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.57812 23.2891C1.15423 23.2891 0 24.4433 0 25.8672V31.0234C0 32.4472 1.15423 33.6016 2.57812 33.6016C4.00202 33.6016 5.15625 32.4472 5.15625 31.0234V25.8672C5.15625 24.4433 4.00202 23.2891 2.57812 23.2891Z",
    fill: "#EB2019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.86719 18.1328C3.15468 18.1328 2.57812 18.7094 2.57812 19.4219V20.7109C5.42188 20.7109 7.73438 23.0234 7.73438 25.8672V31.0234C7.73438 33.8672 5.42188 36.1797 2.57812 36.1797V37.4688C2.57812 38.1813 3.15468 38.7578 3.86719 38.7578C10.4759 38.7578 15.7601 40.8449 20.7109 44V22.3089C15.7377 19.4575 10.3901 18.1328 3.86719 18.1328Z",
    fill: "#EB2019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4219 20.7109V19.4219C41.4219 18.7094 40.8453 18.1328 40.1328 18.1328C33.6099 18.1328 28.2623 19.4575 23.2891 22.3089V44C28.2399 40.8449 33.5241 38.7578 40.1328 38.7578C40.8453 38.7578 41.4219 38.1813 41.4219 37.4688V36.1797C38.5781 36.1797 36.2656 33.8672 36.2656 31.0234V25.8672C36.2656 23.0234 38.5781 20.7109 41.4219 20.7109Z",
    fill: "#EB2019"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1556_7581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRead);
export default __webpack_public_path__ + "static/media/icon-read.40f78958f74091f860c83cf45a5f0fd0.svg";
export { ForwardRef as ReactComponent };